import React from 'react';
import { useQuery } from 'react-query';
import { useParams } from 'react-router-dom';
import { adminAPI } from '../../../api';
import SimpleTabs from '../../../components/SimpleTabSelection';
import EditCohortForm from './EditCohortForm';
import ParticipantsTab from './ParticipantsTab';
import RepresentativesTab from './RepresentativesTab';

const tabs = [
  {
    title: 'Basic Info',
  },
  {
    title: 'Participants',
  },
  {
    title: 'Representatives',
  },
];

const EditCohort = () => {
  const { id } = useParams();
  const { data: cohort, refetch } = useQuery(
    ['getCohortDetails', { id }],
    adminAPI.getCohortDetails
  );

  return (
    <div className="container mx-auto px-2 py-4">
      <div className="pb-4">
        <h1>{cohort?.name}</h1>
        <p className="text-sm font-semibold text-gray-600 mt-2">
        {cohort?.status ? `${cohort?.status}` : ''}
        </p>
      </div>
      <SimpleTabs tabs={tabs} onTabChange={() => refetch()}>
        <EditCohortForm cohort={cohort} onEdited={refetch} />
        <ParticipantsTab cohort={cohort} id={id} refetch={refetch} />
        <RepresentativesTab cohort={cohort} id={id} refetch={refetch} />
      </SimpleTabs>
    </div>
  );
};

export default EditCohort;
